import React, { useState } from "react";
import styles from "./IceCalculator.module.css";
import InputField from "../input/InputField";
import TextComponent from "../textComponent/TextComponent";

const IceCalculatorModal = () => {
  const [waterWeight, setWaterWeight] = useState("");
  const [waterNeeded, setWaterNeeded] = useState("");
  const [waterTemp, setWaterTemp] = useState("");
  const [activeInput, setActiveInput] = useState(null);


  const handleKeyClick = (key) => {
    if (!activeInput) return; 

    if (key === "Reset") {
          setWaterWeight("");
          setWaterTemp("");
          setWaterNeeded("");
    } else {
      switch (activeInput) {
        case "weight":
          setWaterWeight((prev) => prev + key);
          break;
        case "temp":
          setWaterTemp((prev) => prev + key);
          break;
        case "needed":
          setWaterNeeded((prev) => prev + key);
          break;
        default:
          break;
      }
    }
  };

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContainer}>
        {/* Inputs */}
        <div className={styles.inputSection}>
          <div className={styles.row}>
            <div
              className={styles.inputGroup}
              onClick={() => setActiveInput("weight")}
            >
              <InputField
                label="Weight of Water"
                inputStyle={{
                  backgroundColor: "#F7F8F9",
                  border: "1.5px solid #E8ECF4",
                }}
                innerInput={{ backgroundColor: "#F7F8F9" }}
                placeholder={"30 Lbs"}
                value={waterWeight}
                readOnly
              />
            </div>
            <div
              className={styles.inputGroup}
              onClick={() => setActiveInput("temp")}
            >
              <InputField
                label="Tap Water Temperature"
                inputStyle={{
                  backgroundColor: "#F7F8F9",
                  border: "1.5px solid #E8ECF4",
                }}
                innerInput={{ backgroundColor: "#F7F8F9" }}
                placeholder={"70 F"}
                value={waterTemp}
                readOnly
              />
            </div>
          </div>

          <div className={styles.row}>
            <div
              className={`${styles.inputGroup} ${styles.full}`}
              onClick={() => setActiveInput("needed")}
            >
              <InputField
                label="Water Temperature Needed"
                inputStyle={{
                  backgroundColor: "#F7F8F9",
                  border: "1.5px solid #E8ECF4",
                }}
                innerInput={{ backgroundColor: "#F7F8F9" }}
                placeholder={"60 F"}
                value={waterNeeded}
                readOnly
              />
            </div>
          </div>
        </div>

        {/* Results */}
        <div className={styles.resultSection}>
          <div className={styles.resultRow}>
            <TextComponent
              text={"Weight of ice (lbs.)"}
              className={styles.ResultLabel}
            />
            <TextComponent text={"3.125"} className={styles.ResultValue} />
          </div>
          <div className={styles.resultRow}>
            <TextComponent
              text={"Weight of H₂O (lbs.)"}
              className={styles.ResultLabel}
            />
            <TextComponent text={"26.875"} className={styles.ResultValue} />
          </div>
        </div>

        {/* Keypad */}
        <div className={styles.keypad}>
          {["7", "8", "9", "Reset", "3", "4", "5", "6", ".", "0", "1", "2"].map(
            (key) => (
              <button
                key={key}
                className={`${styles.key} ${
                  key === "Reset" ? styles.reset : ""
                }`}
                onClick={() => handleKeyClick(key)}
              >
                {key}
              </button>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default IceCalculatorModal;
